import type { IconNode, LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

// The generic Workflow mark: a check inside a twelve-lobed seal.
export const WORKFLOW_NODES: IconNode = [
  ['path', { key: 'workflow-0', d: 'M8 12L10.6667 15L16 9' }],
  [
    'path',
    {
      key: 'workflow-1',
      d: 'M12 2L14.5957 4.01113L17.8779 3.90983L18.7957 7.0626L21.5106 8.90983L20.4 12L21.5106 15.0902L18.7957 16.9374L17.8779 20.0902L14.5957 19.9889L12 22L9.40426 19.9889L6.12215 20.0902L5.20426 16.9374L2.48944 15.0902L3.6 12L2.48944 8.90983L5.20426 7.0626L6.12215 3.90983L9.40426 4.01113L12 2Z',
    },
  ],
]

export const WorkflowIcon: LucideIcon = createLucideIcon(
  'workflow',
  WORKFLOW_NODES,
)
